import { render, staticRenderFns } from "./Onair.vue?vue&type=template&id=77df144e&"
import script from "./Onair.vue?vue&type=script&lang=js&"
export * from "./Onair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports